import sal from 'sal.js';

class Intersection {
    constructor() {
        this.sal = sal({
            threshold: 0.1,
        });

        this.init();
    }

    init() {
        this.registerEvents();
    }

    shouldRemoveTransitionDelay() {
        return this.sal.elements.filter(element => ('resetTransitionAttributes' in element.dataset));
    }

    registerEvents() {
        const elements = this.shouldRemoveTransitionDelay();

        elements.forEach((element) => {
            element.addEventListener('transitionend', (event) => {
                event.target.classList.add('reset-transition-attributes');
            });
        });
    }
}

const intersection = {
    init() {
        this.object = new Intersection();
    },
};

export default intersection;
